import { ConfigProvider, Flex, Pagination, Select } from "antd";
import { useTranslation } from "react-i18next";

type AppPaginationProps = {
  className?: string;
  total?: number;
  pageSize?: number;
  currentPage?: number;
  onChangePageSize?: (pageSize: number) => void;
  onChangePage?: (page: number, pageSize: number) => void;
};

const AppPagination = (props: AppPaginationProps) => {
  const { t } = useTranslation();

  return (
    <Flex className={props.className} justify={"flex-start"}>
      <Flex className={"flex-1 items-center mr-3"}>
        <div className={"mr-1"}>{t("field.display")}</div>
        <Select
          value={props.pageSize || 10}
          style={{ width: 66 }}
          onChange={props.onChangePageSize}
          options={[
            { value: 10, label: "10" },
            { value: 20, label: "20" },
            { value: 50, label: "50" },
            { value: 100, label: "100" },
          ]}
        />
      </Flex>
      <ConfigProvider
        theme={{
          components: {
            Pagination: {
              itemActiveBg: "#4A58EC",
              itemBg: "#F6F6F8",
            },
          },
        }}
      >
        <Pagination
          current={props?.currentPage ? props?.currentPage + 1 : 1}
          pageSize={props.pageSize}
          total={props.total}
          onChange={props.onChangePage}
          onShowSizeChange={(_, size) => props.onChangePageSize?.(size)}
        />
      </ConfigProvider>
    </Flex>
  );
};

export default AppPagination;
